import { combineReducers } from 'redux'

import { organizationDetailsModalReducer } from '../components/OrganizationDetailsModal/duck/reducers'
import { ORGANIZATION_DETAILS_MODAL_STORE_ID } from '../components/OrganizationDetailsModal/duck/types'
import { dashboardDataReducer } from '../data/reducers'
import { dealManagerReducer } from '../scenes/DealManager/duck/reducers'
import { DEAL_MANAGER_STATE_ID } from '../scenes/DealManager/duck/types'
import { organizationsManagerReducer } from '../scenes/OrganizationsManager/duck/reducers'
import { ORGANIZATIONS_MANAGER_STORE_ID } from '../scenes/OrganizationsManager/duck/types'
import { peopleManagerReducer } from '../scenes/PeopleManager/duck/reducers'
import { PEOPLE_MANAGER_STORE_ID } from '../scenes/PeopleManager/duck/types'
import { DashboardAction } from './actions'
import { DashboardState } from './types'

export const dashboardReducer = combineReducers<DashboardState, DashboardAction>({
  scenes: combineReducers<DashboardState['scenes']>({
    [ORGANIZATIONS_MANAGER_STORE_ID]: organizationsManagerReducer,
    [PEOPLE_MANAGER_STORE_ID]: peopleManagerReducer,
    [DEAL_MANAGER_STATE_ID]: dealManagerReducer,
  }),
  components: combineReducers<DashboardState['components']>({
    [ORGANIZATION_DETAILS_MODAL_STORE_ID]: organizationDetailsModalReducer,
  }),
  data: dashboardDataReducer,
})
